/**
 * Licensed Materials - Property of IBM
 * 5737-M66, 5900-AAA, 5900-A0N, 5725-S86, 5737-I75
 * © Copyright IBM Corp. 2020, 2023 All Rights Reserved.
 * US Government Users Restricted Rights - Use, duplication, or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
import React from 'react';
import PropTypes from 'prop-types';
import { useField } from 'formik';

const propTypes = {
  id: PropTypes.string.isRequired,
  /** if the form value needs to be rendered differently than it is stored */
  renderDataFunction: PropTypes.func,
  labelText: PropTypes.string,
  hideLabel: PropTypes.bool,
};

const defaultProps = {
  labelText: '',
  hideLabel: false,
  renderDataFunction: null,
};

const TextValueFormik = ({ id, labelText, hideLabel, renderDataFunction }) => {
  const [field] = useField(id);

  return (
    <div
      className={['text-value-formik', ...(!hideLabel ? ['text-value-formik--labelled'] : [])].join(
        ' '
      )}>
      {!hideLabel ? <div className="text-value-formik--label">{labelText}</div> : undefined}
      <div className="text-value-formik--value">{`${
        renderDataFunction ? renderDataFunction(field.value) : field.value
      }`}</div>
    </div>
  );
};

TextValueFormik.propTypes = propTypes;
TextValueFormik.defaultProps = defaultProps;

export default TextValueFormik;
